import React, { useState, useEffect } from 'react';
import { studentService } from '../../services/api';
import { getUserData } from '../../utils/auth';
import './CoordinatorPendingStudents.css';

function CoordinatorPendingStudents() {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const collegeId = getUserData()?.collegeId || getUserData()?.CollegeId;

  useEffect(() => {
    if (collegeId) {
      studentService.getPendingStudentsByCollege(collegeId)
        .then(setPending)
        .catch((e) => { setError(e.message); setPending([]); })
        .finally(() => setLoading(false));
    } else {
      setError('College not found');
      setLoading(false);
    }
  }, [collegeId]);

  const handleApprove = async (student) => {
    try {
      const coordId = getUserData()?.cordinatorId || getUserData()?.CordinatorId;
      await studentService.approveStudent(student.Id, coordId);
      setPending((prev) => prev.filter((s) => s.Id !== student.Id));
    } catch (e) {
      alert('Failed to approve: ' + e.message);
    }
  };

  const viewMarksheet = (student) => {
    studentService.downloadMarksheet(student.Id, (student.MarksheetPath || '').split(/[/\\]/).pop() || 'marksheet.pdf').catch((e) => alert(e.message));
  };

  if (loading) return <div className="coord-pending-loading">Loading pending students...</div>;
  if (error) return <div className="coord-pending-error">{error}</div>;

  return (
    <div className="coord-pending-students">
      <h1>Pending Student Approvals</h1>
      <p className="subtitle">Students from your college waiting for approval. After approval they can apply for jobs.</p>
      {pending.length === 0 ? (
        <p className="no-pending">No pending student registrations.</p>
      ) : (
        <div className="pending-list">
          {pending.map((s) => (
            <div key={s.Id} className="pending-card">
              <div className="pending-info">
                <h3>{s.Name}</h3>
                <p><strong>Email:</strong> {s.Email}</p>
                <p><strong>Mobile:</strong> {s.MobileNo}</p>
                <p><strong>College:</strong> {s.College?.Name || '-'}</p>
                <p><strong>University Reg No:</strong> {s.UniversityRegNo || '-'}</p>
                <p>
                  <strong>Marksheet:</strong>{' '}
                  {s.MarksheetPath ? (
                    <button type="button" className="link-btn" onClick={() => viewMarksheet(s)}>View PDF</button>
                  ) : '-'}
                </p>
              </div>
              <div className="pending-actions">
                <button type="button" className="btn-approve" onClick={() => handleApprove(s)}>Approve</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CoordinatorPendingStudents;
